import { StateCreator } from "zustand";
import { SlicedStore } from "../store";

export interface PopupSlice {
  // isPopupShown: boolean;
  // showPopup: (visible: boolean) => void;
  isDocProcessingShown: boolean;
}

export const createPopupSlice: StateCreator<SlicedStore, [], [], PopupSlice> = (
  set
) => ({
  // isPopupShown: false,
  // showPopup: (visible) => set(() => ({ isShown: visible })),
  isDocProcessingShown: false,
});

export {};
